export enum ZIP_COVERAGE_COLUMN_NAME {
  PARCEL_CENTER_ID = "parcelCenterId",
  PARCEL_CENTER_NAME = "parcelCenterName",
  ZIP_CODE = "zipCode",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
}

export enum ZIP_COVERAGE_LABEL_NAME {
  PARCEL_CENTER_NAME = "Parcel Center Name",
  ZIP_CODE = "Zip Code",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",
}

export const ZIP_COVERAGE_FILTER_COLUMN_OPTIONS = [
  {
    label: ZIP_COVERAGE_LABEL_NAME.PARCEL_CENTER_NAME,
    value: ZIP_COVERAGE_COLUMN_NAME.PARCEL_CENTER_NAME,
  },
  {
    label: ZIP_COVERAGE_LABEL_NAME.ZIP_CODE,
    value: ZIP_COVERAGE_COLUMN_NAME.ZIP_CODE,
  },
  // {
  //   label: ZIP_COVERAGE_LABEL_NAME.CREATED_ON,
  //   value: ZIP_COVERAGE_COLUMN_NAME.CREATED_ON,
  // },
  // {
  //   label: ZIP_COVERAGE_LABEL_NAME.UPDATED_ON,
  //   value: ZIP_COVERAGE_COLUMN_NAME.UPDATED_ON,
  // }
];
